import { UseFormReturnType } from "@mantine/form"

import { EventsRequests } from "@costory/types/endpoints/events"
import { Filters } from "@costory/types/filters"
import { EventCategory } from "@costory/types/prisma-client"

import { Dayjs } from "@costory/shared/dayjs"

import { useChartContext } from "@costory/front/contexts/ChartContext"
import { EventsEditModal } from "@costory/front/pages/Events/EventsForm"
import { useCreateNewEventMutation } from "@costory/front/queries/events"
import { disableAllEventSources } from "@costory/front/utils/charts"

export const NewEventForm = ({
  isOpen,
  onClose,
  defaultCategory,
  defaultDate,
  currentView,
  onSaveCallback,
  savedViewId,
  selectedDateRange,
  autoBookmarkEvents,
  advancedExplorerForm,
}: {
  isOpen: boolean
  onClose: () => void
  defaultDate?: string
  defaultCategory?: EventCategory
  currentView: Filters
  onSaveCallback?: (category: EventCategory, eventDate?: string) => void
  savedViewId?: string
  selectedDateRange?: { from: Dayjs; to: Dayjs }
  autoBookmarkEvents?: boolean
  advancedExplorerForm?: UseFormReturnType<Filters>
}) => {
  const { mutateAsync: createEvent } = useCreateNewEventMutation({
    closeModal: onClose,
    selectedDateRange,
    currentView,
  })
  const { filterForm, setURLFilters } = useChartContext()
  const formWithBookmarkedEvents = advancedExplorerForm ?? filterForm

  const bookmarkedEventsCount =
    advancedExplorerForm?.getValues().bookmarkedEvents?.length ?? 0
  const bookmarkDisabled = bookmarkedEventsCount >= 2

  const onSave = async (event: EventsRequests.EventForm) => {
    const payload = savedViewId ? { ...event, savedViewId } : event
    const newEventId = await createEvent(payload)
    const prev = formWithBookmarkedEvents.getValues().bookmarkedEvents || []
    const next = [...new Set([...prev, newEventId])]
    if (savedViewId) {
      formWithBookmarkedEvents.setFieldValue("bookmarkedEvents", next)
      setURLFilters({
        ...formWithBookmarkedEvents.getValues(),
        bookmarkedEvents: next,
      })
      disableAllEventSources(filterForm)
    }
    if (autoBookmarkEvents && !bookmarkDisabled) {
      formWithBookmarkedEvents.setFieldValue("bookmarkedEvents", next)
    }
    if (onSaveCallback) onSaveCallback(event.category, event.date)
  }

  return (
    <EventsEditModal
      onSave={onSave}
      isOpen={isOpen}
      onClose={onClose}
      defaultDate={defaultDate}
      defaultCategory={defaultCategory}
      currentView={currentView}
    />
  )
}
